module.exports = __webpack_public_path__ + "static/full01-e4a146fa43ec3a550f4d03b43efd8c86.png";